module.exports = __webpack_public_path__ + "img/rose.ae3297d2.jpg";